import { Navigate, useLocation } from "react-router-dom";
import { WIX_REDIRECTS } from "@/lib/redirects";

export default function RedirectFromOldWix() {
  const { pathname, search, hash } = useLocation();
  const target = WIX_REDIRECTS[pathname.toLowerCase().replace(/\/$/, "") || "/"];
  if (target) {
    return <Navigate to={target + search + hash} replace />;
  }
  return null;
}
